import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useSession } from '@marketplace-web/shared/session-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import {
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem,
} from '@marketplace-web/browser/browser-storage-util'
import { VanAdEligibleScreen } from '@marketplace-web/ads/ads-data'

import { HAS_ROKT_BEEN_SHOWN_SESSION_KEY, SHOULD_SHOW_ROKT_SESSION_KEY } from '../../constants'

function useShouldShowRokt() {
  const { screen: screenName } = useSession()
  const isRoktScriptEnabled = useFeatureSwitch('web_ads_rokt_script')
  const shouldUserSeeAds = useAbTest('sqp_ads')?.variant === 'on'

  const inboxScreens: Array<string> = Object.values([
    VanAdEligibleScreen.MessageList,
    VanAdEligibleScreen.MessageReply,
    VanAdEligibleScreen.MessageNew,
  ])
  const isInInbox = inboxScreens.includes(screenName)

  const isRoktAvailable = isRoktScriptEnabled && isInInbox && shouldUserSeeAds

  const shouldShowRokt =
    isRoktAvailable && getSessionStorageItem(SHOULD_SHOW_ROKT_SESSION_KEY) === 'true'

  const hasRoktBeenShown = getSessionStorageItem(HAS_ROKT_BEEN_SHOWN_SESSION_KEY) === 'true'

  function setShouldShowRokt(shouldShowRoktValue: boolean) {
    if (shouldShowRoktValue) {
      setSessionStorageItem(SHOULD_SHOW_ROKT_SESSION_KEY, String(shouldShowRoktValue))

      return
    }

    removeSessionStorageItem(SHOULD_SHOW_ROKT_SESSION_KEY)
  }

  function setRoktWasShown() {
    setSessionStorageItem(HAS_ROKT_BEEN_SHOWN_SESSION_KEY, String(true))
  }

  return {
    setShouldShowRokt,
    shouldShowRokt,
    setRoktWasShown,
    hasRoktBeenShown,
  }
}

export default useShouldShowRokt
